import type { AuthTokens } from '~/redux/api/routes/loginApi/models';
import { LocalStorageApi } from './';

export class AuthAccessor {
  static setTokens(data: AuthTokens): void {
    LocalStorageApi?.setItem<string>('access_token', data.access_token);
    LocalStorageApi?.setItem<string>('refresh_token', data.refresh_token);
  }

  static getAccessToken(): string | null {
    return LocalStorageApi?.getItem<string>('access_token') ?? null;
  }

  static getRefreshToken(): string | null {
    return LocalStorageApi?.getItem<string>('refresh_token') ?? null;
  }

  static clearTokens(): void {
    LocalStorageApi?.removeItem('access_token');
    LocalStorageApi?.removeItem('refresh_token');
  }
}
